import { render, staticRenderFns } from "./YourRecipes.vue?vue&type=template&id=43f47a58&scoped=true&"
import script from "./YourRecipes.vue?vue&type=script&lang=js&"
export * from "./YourRecipes.vue?vue&type=script&lang=js&"
import style0 from "./YourRecipes.vue?vue&type=style&index=0&id=43f47a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f47a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VContainer,VDivider,VIcon,VRow,VSnackbar})
